import { render } from "./SubmitOnboardingSurvey.vue?vue&type=template&id=00cf7d0c"
import script from "./SubmitOnboardingSurvey.vue?vue&type=script&lang=js"
export * from "./SubmitOnboardingSurvey.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "../i18n/SubmitSurvey.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Fpeeristics%2Frails-frontend%2Fapp%2Fassets%2Fvue%2Fsurveys%2Fcomponents%2FSubmitOnboardingSurvey.vue&lang=yml&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__